<div class="dialog">
    <div class="dialog-header">
        <h3>{{ 'SALES_DOCUMENT|Dodać produkt do nowej oferty?' | translate}}</h3>
        <button 
            iccIconButton 
            (click)="close()"
            appearance="flat"
        >
            <icc-icon name="close"></icc-icon>
        </button>
    </div>
    <div class="dialog-body">
        <p *ngIf="!data.variant">{{ 'SALES_DOCUMENT|Aktualny dokument ({documentNumber}) nie jest otwarty do edycji. Czy dodać produkt do nowej oferty?' | translate: {documentNumber: documentNumber} }}</p>
        <p *ngIf="data.variant">{{ 'SALES_DOCUMENT|Aktualny dokument ({documentNumber}) nie pozwala na dodanie wybranego produktu. Czy dodać produkt do nowej oferty?' | translate: {documentNumber: documentNumber} }}</p>
     
    </div>
    <div class="dialog-footer">
        <div class="flex-horizontal w-100">
            <button iccButton appearance="flat" (click)="close()">{{ 'INTERFACE|Anuluj' | translate}}</button>
            <div class="flex-horizontal right">
                <button iccButton (click)="createQuotation()">{{ 'SALES_DOCUMENT|Dodaj do nowej oferty' | translate}}</button>
            </div>
        </div>
    </div>
</div>
<div 
    class="curtain"
    (click)="close()"
></div>